import { EmptyNumberFormatter, EmptyOddFormatters } from "./EmptyNumberFormatter";
export var OddStyles;
(function (OddStyles) {
    OddStyles[OddStyles["american"] = 0] = "american";
    OddStyles[OddStyles["decimal"] = 1] = "decimal";
    OddStyles[OddStyles["fractional"] = 2] = "fractional";
    OddStyles[OddStyles["hk"] = 3] = "hk";
    OddStyles[OddStyles["malay"] = 4] = "malay";
    OddStyles[OddStyles["indo"] = 5] = "indo";
})(OddStyles || (OddStyles = {}));
export class DecimalLocalizator {
    constructor(config) {
        this.oddFormatters = config.oddFormatters || EmptyOddFormatters;
        this.pointFormatter = config.pointFormatter || EmptyNumberFormatter;
        this.moneyFormatter = config.moneyFormatter || EmptyNumberFormatter;
        this.numberFormatter = config.numberFormatter || EmptyNumberFormatter;
    }
    localizeOdd(odd, oddStyle) {
        if (!odd) {
            return "";
        }
        return /\d/.test(odd) ? this.getOddFormatter(oddStyle).format(odd) : odd;
    }
    localizePoint(point) {
        return this.localizeValue(this.pointFormatter, point);
    }
    localizeMoney(number) {
        return this.localizeValue(this.moneyFormatter, number);
    }
    localizeNumber(number) {
        return this.localizeValue(this.numberFormatter, number);
    }
    getOddFormatter(oddStyle) {
        switch (oddStyle) {
            case OddStyles.decimal:
                return this.oddFormatters.European;
            case OddStyles.malay:
                return this.oddFormatters.Malay;
            case OddStyles.indo:
                return this.oddFormatters.Indo;
            case OddStyles.hk:
                return this.oddFormatters.Hongkong;
        }
        return EmptyNumberFormatter;
    }
    localizeValue(formatter, decimalValue) {
        if (decimalValue !== undefined && decimalValue !== null) {
            return formatter.format(decimalValue);
        }
        return "";
    }
}
//# sourceMappingURL=DecimalLocalizator.js.map